module.exports = __webpack_public_path__ + "img/gold.0f3e11a6.svg";